import React from 'react';
import {Col} from '~/components/elements';

interface Props {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const PopupLayout = ({children, style}: Props) => {
  return (
    <Col px={6} py={5} style={style}>
      {children}
    </Col>
  );
};
